import { NavigationSection, Topics } from '@app/context/constants';
import { topicUrl } from '@app/context/utils';
import { useNavigation } from '@app/hooks/useNavigation';
import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import { useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Dashboard } from '../useDashboard';
import { Topic } from './Topic';

function TopicRedirect() {
  const { navigateDashboard } = useNavigation();

  useEffect(() => {
    navigateDashboard(NavigationSection.Overview);
  }, []);

  return null;
}

interface Props {
  dashboard: Dashboard;
}

export function TopicRoutes({ dashboard }: Props) {
  const { path } = useRouteMatch();
  const { topics } = useUserWithCompany();

  return (
    <Switch>
      {Object.entries(Topics).map(([key, value]) => {
        const thisTopic = topics.find((t) => t.id === value);
        if (!thisTopic) return null;
        return (
          <Route key={key} path={`${path}${topicUrl(value)}`}>
            <Topic topic={thisTopic} dashboard={dashboard} />
          </Route>
        );
      })}
      <Route path={`${path}`}>
        <TopicRedirect />
      </Route>
    </Switch>
  );
}
